const API_VERSION = 'v1'

export const API_SERVER = `${process.env.REACT_APP_API_URL}`

export const API_SERVER_RETENTION = `${process.env.REACT_APP_API_URL_RETENTION}/api/${API_VERSION}`

export const API_ROOT = `${API_SERVER}/api/${API_VERSION}`

export const HUB_ROOT = `${API_SERVER}/hub`

export const CONTENT_ROOT = `${API_SERVER}`

export const BLOB_STORAGE = 'https://plantscannerstorage.blob.core.windows.net'

export const AZURE_FUNCTIONS = 'https://plantscanner-functions.azurewebsites.net/api'

export const FULLCALENDAR_LICENSE_KEY = '0528973692-fcs-1600177722'

export const APP_INSIGHTS_KEY = '7e4a6a65-2a03-4379-b6ac-f6699c5888c5'

export const TENANTS_IN_TEST = ['fras-le-siblo']

export const TENANTS_IN_TEST_WORK_ORDER_VALIDATION = [
  'aes',
  'dev-azure',
  'demo-alimentos',
  'spraytec-embalagem',
  'spraytec-fertilizantes',
  'spraytec-inoculantes',
  'spraytec-pellet',
  'spraytec-solidos',
  'ocq',
]

export const TENANTS_IN_TEST_WORK_ORDER_NO_VALUE_VALIDATION = [
  'aes',
  'dev-azure',
  'demo-alimentos',
  'spraytec-embalagem',
  'spraytec-fertilizantes',
  'spraytec-inoculantes',
  'spraytec-pellet',
  'spraytec-solidos',
  'f2j',
  'ocq',
]

export const PLANTSCANNER_DEFAULT_ZPL = `4x3.2\n
^XA
^CI28
^CF0,30; Set font type to 0 (default) and font size to 30 points

; Work Order Label at the top center
^FO40,30^FB700,1,0,C^FDEtiqueta de Producao^FS

; Work Order Code (Centered)
^A0N,50,50^FO20,100^FB750,1,0,C^FDCodigo: [workOrderCode]^FS

; Product Description (Left-aligned)
^FO20,210^FB750,3,0,L^FD[description]^FS

; Date (Left-aligned)
^FO20,250^FB750,1,0,L^FDData: [currentDate]^FS

; Produced Quantity (Left-aligned)
^FO20,290^FB750,1,0,L^FDQuantidade produzida: [workOrderProducedGoodQuantity][materialUoM]^FS

; Work Order Batch (Left-aligned)
^FO20,330^FB750,1,0,L^FDLote: [workOrderGrouper]^FS

; Observação (Left-aligned)
^FO20,370^FB750,1,0,L^FDObservação: [printNote]^FS

; QR Code (Right-aligned between Product Description and Work Order Batch)
^FO600,440^BQN,2,4^FDMA,https://portal.plantscanner.io/dashboard/work-order?code=[workOrderCode]&operationCode=[operationCode]^FS

; Plant Scanner Name (Left-aligned)
^FO30,550^GFA,3150,3150,50,K03FE,J03FFE,J0IFE,I03IFE,I0JFE,001JFE,003JFE,00IFCV0IFC0078M078I038I0E1KF803FFCI03FEJ01EJ0EI03878001C1JFC1IF8,01FFEV01JF0078M07CI03CI0E1KF81IFCI0IF8I01FI01FI0787C001E3JFE3IFE,01FF8V01JFC078M07CI03EI0E1KF83IFC003IFEI03FI01F800787E001E3JFE3JF803FEW01JFE078M0FEI03FI0E1KF87IFC007F8FFI03F8001FC00787E001E3JFC3JFC07FCW01E003F078M0FEI03F800EI0FI078K0FC01F8007F8001FE00787F001E3CJ03C007C0FF8W01EI0F078L01FFI03FC00EI0FI0FK01FI07I0778001FF00787F801E3CJ03C001E0FFX01EI0F878L01EFI03BE00EI0FI0FK03EM073C001EF80787FC01E3CJ03C001E1FEX01EI07878L03CFI039F00EI0FI0EK07CM0F3C001E780787BE01E3CJ03CI0!1FCX01EI07878L03C780038F00EI0FI0EK078M0E1E001E3C07879F01E3CJ03CI0!3FCX01EI07878L078780038780EI0FI0FK0FM01E1E001E3E07878F81E3CJ03CI0!3F8X01EI07878L0783C00387C0EI0FI0FK0FM01C0F001E1F078787C1E3CJ03CI0!7F8X01EI07878L0783C00383E0EI0FI0F8J0FM03C0F001E0F878783C1E3IFE03CI0!7FY01EI07878L0F01E00381F0EI0FI07CJ0EM0380F001E07C78781E1E3IFE03CI0!7FY01EI0F078L0F01E00380F8EI0FI03FFE00EM03807801E03E78781F1E3IFE03C001EFEJ0FES01E001F078K01E01E003807CEI0FI01IF80EM07807801E01F78780F9E3IFC03C003EFEI01FFS01E007E078K01E00F003803EEI0FJ0IFC0EM07003C01E00F787807DE3CJ03C00FCFEI03FF8R01JFC078K03C00F003801FEI0FL07C0EM0F003C01E007F87803FE3CJ03JF8K07FFCR01JF8078K03C007803800FEI0FL03E0FM0E001E01E007F87801FE3CJ03JF,K07FFCR01IFE0078K038007803800FEI0FL01E0FL01E001E01E003F87800FE3CJ03IFC,K07FFCR01EK078K078003C038007EI0FM0F0FL01C001F01E001F878007E3CJ03C03C,K07FFCR01EK078K078003C038003EI0FM0F078K03CI0F01EI0F878003E3CJ03C01E,K07FFCR01EK078K0FI01E038001EI0FM0F07CK038I0F01EI07878003E3CJ03C01E,K07FFCR01EK078K0FI01E038I0EI0FM0E03CK038I0781EI07878001E3CJ03C00F,K07FFCR01EK078J01EI01E038I0EI0FL01E01FI06078I0781EI07878001E3CJ03C00F8K03FF8I07EM01EK078J01EJ0F038I0EI0FL03E01F800F07J03C1EI07878001E3CJ03C0078K01FFJ0FEM01EK07JF83CJ0F038I0EI0FI07IFC00FF8FF0FJ03C1EI07878001E3JFC3C003CL0FEJ0FEM01EK07JF83CJ07838I0EI0FI07IF8003IFE0EJ01E1EI07878001E3JFE3C003ER0FEM01EK07JF83CJ07838I0EI0FI07IFI01IF81EJ01E1EI07878001E3JFE3C001EQ01FCN0EK07JF878J03838I0EI0FI07FFCJ03FE01CK0E0EI03878001C1JFC1CI0!Q01FC,Q03FC,Q03F8,Q07F8,Q07F,Q0FF,P01FE,P03FE,FCN07FC,FEM01FF8,FEM07FFR08007K01C0FC0EQ01C03807C1F8M01C01E,FEL01FFEP04082044041020020108I0601J04004404004021I0C02102,FEK03IFCP040C2042041040020104I0A01J04008204004021880802082,FEJ0KF8P040A2042041020020104I0A01J04008204004002880202082,FEJ0KFQ040A20400410100201K0901J03008207C04012001202003E,FEJ0JFCQ040920400410040201F8001101K0C08204004012501103F02,FEJ0JFR0408A04204100202012I01F81K0408204004004503F02402,FEJ0IFCR0408E04204100202011K081K020820400400C502102202,FEJ0FFES04086044022006020108002081K040440400400C202082102,FEgN018018V03001,FE,:::::,^FS

^XZ
`
